"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const _hoisted_2 = {
    key: 0,
    class: "text-orange-dark text-right"
};
const _hoisted_3 = {
    key: 1,
    class: "flex flex-col lg:flex-row mt-3"
};
const _hoisted_4 = {
    key: 0,
    class: "w-10"
};
const _hoisted_5 = { class: "lg:grow text-right flex justify-end" };
const _hoisted_6 = {
    key: 2,
    class: "text-center text-black"
};
const CartSummary_vue_1 = __importDefault(require("./CartSummary.vue"));
const vue_3 = require("vue");
const vue_router_1 = require("vue-router");
const toastStore_1 = require("../../stores/toast/toastStore");
const i18n_1 = require("../../common/i18n");
const PermissionEnum_1 = require("../../models/permission/PermissionEnum");
const securityStore_1 = require("../../stores/security/securityStore");
const ShopConfig_1 = require("../../common/utils/ShopConfig");
const cartsStore_1 = require("../../stores/carts/cartsStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'CartModal',
    props: {
        id: {
            type: String,
            default: () => { var _a; return `cart-modal-${(_a = (0, vue_3.getCurrentInstance)()) === null || _a === void 0 ? void 0 : _a.uid}`; }
        }
    },
    setup(__props) {
        var _a, _b;
        const props = __props;
        const cartsStore = (0, cartsStore_1.useCartsStore)();
        const router = (0, vue_router_1.useRouter)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const currentUser = (0, vue_3.computed)(() => {
            return securityStore.authenticatedUser;
        });
        const activeCart = (0, vue_3.computed)(() => cartsStore.activeCart);
        const grossTotal = (0, vue_3.ref)((_a = activeCart.value) === null || _a === void 0 ? void 0 : _a.getGrossTotal());
        const cartCurrency = (0, vue_3.ref)((_b = activeCart.value) === null || _b === void 0 ? void 0 : _b.getCurrencyCode());
        const cashPaymentModeDisabledLimits = ShopConfig_1.ShopConfig.getCashPaymentModeDisabledLimits();
        const isStockInfoRefreshButtonHided = (0, vue_3.ref)(false);
        const intervalId = (0, vue_3.ref)(null);
        const countdownDuration = (0, vue_3.ref)(60);
        const countdownInterval = (0, vue_3.ref)(null);
        (0, vue_3.watch)(() => { var _a; return (_a = activeCart.value) === null || _a === void 0 ? void 0 : _a.getGrossTotal(); }, (value) => {
            grossTotal.value = value;
        });
        const startRefreshingStockInfo = () => {
            intervalId.value = window.setInterval(() => refreshStockInfos(), 5 * 60 * 1000);
        };
        const stopRefreshingStockInfo = () => {
            if (intervalId.value !== null) {
                clearInterval(intervalId.value);
                intervalId.value = null;
            }
        };
        const hideStockInfoRefreshButton = () => {
            if (countdownInterval.value) {
                clearInterval(countdownInterval.value);
            }
            isStockInfoRefreshButtonHided.value = false;
            countdownDuration.value = 60;
            countdownInterval.value = setInterval(() => {
                countdownDuration.value--;
                if (countdownDuration.value === 0) {
                    clearInterval(countdownInterval.value);
                    isStockInfoRefreshButtonHided.value = true;
                }
            }, 1000);
        };
        const emptyCart = () => {
            var _a;
            if (activeCart.value === undefined) {
                return;
            }
            const gtagData = {
                currency: activeCart.value.getCurrencyCode(),
                value: activeCart.value.getNetTotal(),
                items: (_a = activeCart.value.products) === null || _a === void 0 ? void 0 : _a.map((product) => {
                    return {
                        item_id: product.id,
                        item_name: product.name,
                        price: product.priceNet,
                        quantity: product.quantity,
                    };
                }),
            };
            cartsStore
                .emptyCart(router)
                .then(() => {
                gtag("event", "remove_from_cart", gtagData);
            })
                .catch((error) => {
                toastStore.addErrorToast(error.toString());
            });
        };
        const needCashPaymentLimitWarning = (0, vue_3.computed)(() => {
            var _a;
            if ((_a = securityStore.authenticatedUser) === null || _a === void 0 ? void 0 : _a.hasPermission(PermissionEnum_1.CustomerPermissionEnum.EXPORT_PARTNER)) {
                return false;
            }
            if (!cartCurrency.value) {
                return false;
            }
            if (!cashPaymentModeDisabledLimits[cartCurrency.value]) {
                return false;
            }
            if (!grossTotal.value) {
                return false;
            }
            if (cashPaymentModeDisabledLimits[cartCurrency.value] * 0.9 <= grossTotal.value) {
                return true;
            }
            return false;
        });
        const refreshStockInfos = () => {
            if (!isStockInfoRefreshButtonHided.value) {
                return;
            }
            else {
                cartsStore
                    .refreshStockInfos(router)
                    .then(() => {
                    hideStockInfoRefreshButton();
                })
                    .catch((error) => {
                    toastStore.addErrorToast(error.toString());
                });
            }
        };
        const goToCheckout = () => {
            var _a, _b;
            if (activeCart.value === undefined) {
                return;
            }
            const products = (_a = activeCart.value.products) !== null && _a !== void 0 ? _a : [];
            const totalValue = Math.round(products.reduce((total, product) => {
                return total + product.priceNet * product.quantity;
            }, 0));
            const gtagData = {
                currency: activeCart.value.getCurrencyCode(),
                value: totalValue,
                items: (_b = activeCart.value.products) === null || _b === void 0 ? void 0 : _b.map((product) => {
                    return {
                        item_id: product.id,
                        item_name: product.name,
                        price: product.priceNet,
                        quantity: product.quantity,
                    };
                }),
            };
            cartsStore.closeActiveCartModal();
            gtag("event", "begin_checkout", gtagData);
            router.push({ name: "shop_checkout" });
        };
        (0, vue_3.watch)(() => { var _a, _b; return (_b = (_a = activeCart.value) === null || _a === void 0 ? void 0 : _a.products) === null || _b === void 0 ? void 0 : _b.length; }, (value) => {
            if (value === 0 && router.currentRoute.value.name == "shop_checkout") {
                router.push({ name: "home" });
            }
        });
        (0, vue_3.onMounted)(() => {
            hideStockInfoRefreshButton();
            startRefreshingStockInfo();
        });
        (0, vue_3.onUnmounted)(stopRefreshingStockInfo);
        return (_ctx, _cache) => {
            var _a, _b, _c;
            const _component_router_link = (0, vue_2.resolveComponent)("router-link");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", { id: __props.id }, [
                (0, vue_2.createVNode)(CartSummary_vue_1.default, { hideStockInfoRefreshButton: hideStockInfoRefreshButton }),
                ((0, vue_2.unref)(needCashPaymentLimitWarning) && cartCurrency.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("disabled_cash_delivery_mode_notification", "If the value of the basket exceeds {value} {cartCurrency} and home delivery is chosen, cash payment option will not be available at the checkout.", "carts", {
                        value: (0, vue_2.unref)(cashPaymentModeDisabledLimits)[cartCurrency.value],
                        cartCurrency: cartCurrency.value
                    })), 1))
                    : (0, vue_2.createCommentVNode)("", true),
                ((0, vue_2.unref)(activeCart) !== undefined && ((_a = (0, vue_2.unref)(activeCart)) === null || _a === void 0 ? void 0 : _a.getSize()) > 0)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("button", {
                            id: "cart-modal-empty-the-cart-button",
                            type: "button",
                            class: "!py-3 btn btn-rounded btn-outline text-red block whitespace-nowrap lg:mr-3 mb-3",
                            onClick: _cache[0] || (_cache[0] = ($event) => (emptyCart()))
                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("empty_the_cart", "Empty the cart", "carts")), 1),
                        (0, vue_2.createElementVNode)("button", {
                            id: "cart-modal-refresh-stock-infos-button",
                            type: "button",
                            class: "!py-3 btn btn-rounded btn-outline text-blue whitespace-nowrap lg:mr-3 mb-3",
                            style: (0, vue_2.normalizeStyle)(!isStockInfoRefreshButtonHided.value
                                ? '--tw-text-opacity: 0.4'
                                : '--tw-text-opacity: 1'),
                            onClick: _cache[1] || (_cache[1] = ($event) => (refreshStockInfos()))
                        }, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("refresh_stock_infos", "Refresh stock infos", "carts")) + " ", 1),
                            (!isStockInfoRefreshButtonHided.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_4, "(" + (0, vue_2.toDisplayString)(countdownDuration.value) + ")", 1))
                                : (0, vue_2.createCommentVNode)("", true)
                        ], 4),
                        (((_b = (0, vue_2.unref)(currentUser)) === null || _b === void 0 ? void 0 : _b.hasPermission((0, vue_2.unref)(PermissionEnum_1.QuotationPermissionEnum).QUOTATION_READ)) &&
                            !((_c = (0, vue_2.unref)(currentUser)) === null || _c === void 0 ? void 0 : _c.hasPermission((0, vue_2.unref)(PermissionEnum_1.CustomerPermissionEnum).EXPORT_PARTNER)))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_router_link, {
                                key: 0,
                                id: "cart-modal-create-printable-quote-link",
                                to: { name: 'shop_quote' },
                                target: "_blank",
                                class: "!py-3 btn btn-rounded btn-warning text-sm sm:text-base font-bold text-[20px] text-center lg:mr-3 whitespace-nowrap mb-3"
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("create_printable_quote", "Create Printable Quote", "carts")), 1)
                                ]),
                                _: 1
                            }))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                            (0, vue_2.createElementVNode)("button", {
                                id: "cart-modal-checkout-button",
                                type: "button",
                                class: "!py-3 w-full lg:w-auto inline-block btn btn-rounded btn-primary",
                                onClick: _cache[2] || (_cache[2] = ($event) => (goToCheckout()))
                            }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("checkout", "Checkout", "carts")), 1)
                        ])
                    ]))
                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("your_cart_is_empty", "Your cart is empty.", "carts")), 1))
            ], 8, _hoisted_1));
        };
    }
});
